<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-progress :percentage="70" type="circle"></ot-progress>
            <ot-progress :percentage="30" type="circle" :stroke-width="38" :width="150"></ot-progress>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-progress%20%3Apercentage%3D%2270%22%20type%3D%22circle%22%3E%3C%2Fot-progress%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-progress%20%3Apercentage%3D%2230%22%20type%3D%22circle%22%20%3Astroke-width%3D%2238%22%20%3Awidth%3D%22150%22%3E%3C%2Fot-progress%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
